import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {isNullOrUndefined} from "util";
import {ActivatedRoute, Router} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {DynamicStylesHelper} from "../../_service/dinamic-styles.service";
import {ViewSettingService} from "../../main-page/view-setting-service/view-setting.service";
import {OrganizationService} from "../../_service/organization.service";

@Component({
  selector: 'app-w-main',
  templateUrl: './inactive-info.component.html',
  // styleUrls: ['./helper.css', './../../css/main.css', './../../css/common.css'],
  encapsulation: ViewEncapsulation.None

})
export class InactiveInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(public viewSettingService: ViewSettingService,
              private route: ActivatedRoute,
              public sanitizer: DomSanitizer,
              private cdr: ChangeDetectorRef,
              private orgService: OrganizationService,
              private router: Router) {
    if (this.route.children.length == 0) {
      // this.router.navigate(['./login'], {relativeTo: this.route});
    }
  }

  data;

  dynamicStylesHelper: DynamicStylesHelper = new DynamicStylesHelper('login-page', ['css/login-fix.css', 'css/main.css', 'css/common.css']);

  public onMainMessage = '';
  public errorMessage = '';

  ngOnInit(): void {
    this.dynamicStylesHelper.addStyles();

    this.orgService.getInactiveInfo(this.route.snapshot.parent.paramMap.get("alias")).then(
      value => {
        this.data = value
      },
      error => {
        this.router.navigate(["error"]);
      }
    )
  }

  ngAfterViewInit(): void {
    this.initSvgAndCss();
  }

  initSvgAndCss() {
    this.viewSettingService.initStylesAndSvg().then((ukName) => {
      this.sanitizer.bypassSecurityTrustResourceUrl('css/theme-' + ukName + '.css');
    });
  }

  ngOnDestroy(): void {
    this.cdr.detach();
    if (document.body.contains(document.getElementById('svg-data'))) {
      document.body.removeChild(document.getElementById('svg-data'));
    }
    if (document.body.contains(document.getElementById('ukStyle'))) {
      document.body.removeChild(document.getElementById('ukStyle'));
    }
    // this.cdr.detectChanges();
    this.dynamicStylesHelper.clearStyles();
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/inactive-info/inactive-info.component.ts